module.exports = __webpack_public_path__ + "img/camilla-hansen.5807c3b5.jpg";